class HeroObserver extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const type = entry.isIntersecting ? 'hero:entered' : 'hero:exited';
        document.dispatchEvent(new CustomEvent(type));
      },
      { threshold: 0 },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('hero-observer')) {
  customElements.define('hero-observer', HeroObserver);
}
